// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KeyList_wrapper__nYgwL","title":"KeyList_title__30UAt","list":"KeyList_list__9Z5gU"};